import React, { useEffect, useState } from 'react';
import { Table, Button, Card, Space, Typography, Empty, Form, Input, Radio, Select, Col, Row, message ,Affix,Spin} from 'antd';
import ApiService from '../Components/apiService';
import { BASE_URL } from '../Components/Constant';
import FiltersDynamic from '../Components/FiltersDynamicComponent';

const { Title } = Typography;
const { Option } = Select;

const SharingSettings = ({ object }) => {
    const [showForm, setShowForm] = useState(false);
    const [form] = Form.useForm();
    const [roles, setRoles] = useState([]);
    const [loading, setLoading] = useState(false);
    const [ruleType, setRuleType] = useState('owner');
    const [selectedRecordToBeShared, setSelectedRecordsToBeShared] = useState(null);
    const [selectedRecordSharedWith, setSelectedRecordsSharedWith] = useState(null);
    const [ownerValues, setOwnerValues] = useState([]);
    const [fields, setFields] = useState([]); // State to store fetched fields
    const [selectedFields, setSelectedFields] = useState([]);
    const [lookupOptions, setLookupOptions] = useState([]); // For storing lookup options
    const [logic, setLogic] = useState('');
    const [operator, setOperator] = useState('AND');
    const [isLogicEditable, setIsLogicEditable] = useState(false);
    const [filters, setFilters] = useState([{ 1: { field: '', value: '', displayValue: '' } }]); // For managing filters
    const [valueOperator, setValueOperator] = useState('');
    const [sharingRules, setSharingRules] = useState([]); // State to store sharing rules


    useEffect(() => {
        fetchRoles();
        fetchFields();
        fetchSharingRules();

    }, []);

    const handleNew = () => {
        form.resetFields();
        setShowForm(true);
    };

    const handleCancel = () => {
        setShowForm(false);
    };

    const fetchFields = async () => {
        try {
            const apiService = new ApiService(
                `${BASE_URL}/mt_fields/object/${object.name}`,
                { 'Content-Type': 'application/json' },
                'GET'
            );
            apiService.makeCall()
                .then(response => {
                    // Assuming the API returns an array of field objects with 'name' and 'label' keys
                    const filteredFields = response.filter(field => field.name !== 'recordCount'); // Filter out 'recordCount'
                    // Update the state with the filtered fields
                    setFields(filteredFields); // Adjust as per API response structure
                })
        } catch (error) {
        }
    };

    const fetchSharingRules = async () => {
        try {
            const apiService = new ApiService(
                `${BASE_URL}/sharing_rules/${object.name}`,
                { 'Content-Type': 'application/json' },
                'GET'
            );
            const res = await apiService.makeCall();
            setSharingRules(res || []);


        } catch (error) {
        }
    };


    const handleSubmit = (values) => {
        console.log('Form values:', values);
        setShowForm(false);
        // you can call your backend save logic here
    };

    const fetchRoles = async () => {
        setLoading(true);
        try {
            const apiServiceForRoles = new ApiService(
                `${BASE_URL}/get_all_user_role`,
                { 'Content-Type': 'application/json' },
                'GET'
            );
            const rolesData = await apiServiceForRoles.makeCall();
            setRoles(rolesData || []);
        }
        catch (error) {
            console.log(error);
        } finally {
            setLoading(false);
        }
    }

    // New function to fetch lookup records based on existing filters
    const fetchLookupRecordsForExistingFilters = (existingFilters) => {
        existingFilters.forEach(filter => {
            const selectedField = fields.find(field => field.name === filter.field?.replace('_id', ''));
            if (selectedField && selectedField.type === 'lookup') {
                fetchLookupRecords(selectedField.parent_object_name); // Fetch records for lookup fields
            }
        });
    };
    // Function to fetch records for the lookup field
    const fetchLookupRecords = async (objectName) => {
        try {
            const apiServiceForRecords = new ApiService(
                `${BASE_URL}/fetch_records/${objectName}`,
                { 'Content-Type': 'application/json' },
                'GET'
            );
            const response = await apiServiceForRecords.makeCall();
            // Assuming response is an array of records with _id and Name fields
            const records = response?.records?.map(record => ({
                value: record._id, // Set _id as value
                label: record.Name, // Set Name as label
            }));
            setLookupOptions(records); // Set options for the lookup field
        } catch (error) {
            const errorMessage = error && typeof error === 'object'
                ? Object.entries(error).map(([key, value]) => `${key}: ${Array.isArray(value) ? value.join(', ') : value}`).join(' | ')
                : 'Failed to save field due to an unknown error';
            message.error(errorMessage);
        }
    };
 

    const handleRecordToBeShared = async (value) => {
        setSelectedRecordsToBeShared(value);
        if (value === 'roles') {
            setOwnerValues(roles);
        } else if (value === 'public_groups') {
            setOwnerValues([
                { Name: 'Marketing Team', value: 'marketing' },
                { Name: 'Support Team', value: 'support' },
            ]);
        } else {
            setOwnerValues([]);
        }
    };

    const handleRecordSharedWith = async (value) => {
        setSelectedRecordsSharedWith(value);
        if (value === 'roles') {
            setOwnerValues(roles);
        } else if (value === 'public_groups') {
            setOwnerValues([
                { Name: 'Marketing Team', value: 'marketing' },
                { Name: 'Support Team', value: 'support' },
            ]);
        } else {
            setOwnerValues([]);
        }
    };

    const onEdit = (rule) => { }
    const onDelete = (rule) => { }

    const columns = [
        {
            title: 'Name',
            dataIndex: 'name',
            key: 'name',
        },
        {
            title: 'Criteria',
            dataIndex: 'criteria',
            key: 'criteria',
            render: (criteria) => criteria || '—',
        },
        {
            title: 'Actions',
            key: 'actions',
            render: (_, rule) => (
                <Space>
                    <Button type="link" onClick={() => onEdit(rule)}>Edit</Button>
                    <Button type="link" danger onClick={() => onDelete(rule)}>Delete</Button>
                </Space>
            ),
        },
    ];

    return (
        <div >
            {showForm ? (
                <Card title="Create New Sharing Rule" style={{  height: '100vh', overflowY: 'scroll'}}>
                    <Form form={form} layout="vertical" onFinish={handleSubmit}>
                        <Title level={4}>Step 1: Rule Name</Title>
                        <Form.Item label="Label" name="label" rules={[{ required: true }]}>
                            <Input />
                        </Form.Item>
                        <Form.Item label="Rule Name" name="ruleName" rules={[{ required: true }]}>
                            <Input />
                        </Form.Item>
                        <Form.Item label="Description" name="description">
                            <Input.TextArea />
                        </Form.Item>

                        <Title level={4}>Step 2: Select your rule type</Title>
                        <Form.Item name="ruleType" initialValue="owner" onChange={(e) => setRuleType(e.target.value)}>
                            <Radio.Group>
                                <Radio value="owner">Based on record owner</Radio>
                                <Radio value="criteria">Based on criteria</Radio>
                            </Radio.Group>
                        </Form.Item>

                        <Title level={4}>Step 3: Select which records to be shared</Title>
                        <Form.Item >
                            {ruleType === 'owner' ? (
                                <Row gutter={16}>
                                    <Col span={6}>
                                        <Title level={5}>Account: owned by members of</Title>
                                    </Col>

                                    <Col span={9}>
                                        <Form.Item name="recordToBeShare" rules={[{ required: true }]}>
                                            <Select placeholder="Select Owner Type" onChange={handleRecordToBeShared}>
                                                <Option value="roles">Roles</Option>
                                                <Option value="public_groups">Public Groups</Option>
                                                {/* Add more options as needed */}
                                            </Select>
                                        </Form.Item>
                                    </Col>
                                    <Col span={9}>
                                        <Form.Item name="recordToBeSharedValue" rules={[{ required: true }]}>
                                            <Select placeholder="Select value" disabled={!selectedRecordToBeShared}>
                                                {ownerValues.map((item) => (
                                                    <Option key={item.Name} value={item.Name}>{item.Name}</Option>
                                                ))}
                                            </Select>
                                        </Form.Item>
                                    </Col>
                                </Row>
                            ) : (
                                <div >
                                    <Form.Item>
                                        <FiltersDynamic
                                            fields={fields}
                                            logic={logic}
                                            setLogic={setLogic}
                                            filters={filters}
                                            setFilters={setFilters}
                                            setValueOperator={setValueOperator}
                                            valueOperator={valueOperator}
                                            fetchLookupRecordsForExistingFilters={fetchLookupRecordsForExistingFilters}
                                            fetchLookupRecords={fetchLookupRecords}
                                            lookupOptions={lookupOptions}
                                        >
                                        </FiltersDynamic>
                                    </Form.Item>

                                </div>
                            )}
                        </Form.Item>

                        <Title level={4}>Step 4: Select the users to share with</Title>
                        <Form.Item  name="shareWith" >
                             <Row gutter={16}>
                                    <Col span={6}>
                                        <Title level={5} >Share with</Title>
                                    </Col>

                                    <Col span={9}>
                                        <Form.Item name="recordToBeSharedWith" rules={[{ required: true }]}>
                                            <Select placeholder="Select Owner Type" onChange={handleRecordSharedWith}>
                                                <Option value="roles">Roles</Option>
                                                <Option value="public_groups">Public Groups</Option>
                                                {/* Add more options as needed */}
                                            </Select>
                                        </Form.Item>
                                    </Col>
                                    <Col span={9}>
                                        <Form.Item name="recordSharedWithValue" rules={[{ required: true }]}>
                                            <Select placeholder="Select value" disabled={!selectedRecordSharedWith}>
                                                {ownerValues.map((item) => (
                                                    <Option key={item.Name} value={item.Name}>{item.Name}</Option>
                                                ))}
                                            </Select>
                                        </Form.Item>
                                    </Col>
                                </Row>
                        </Form.Item>

                    
                        <Affix offsetBottom={0}>
                            <div
                                style={{
                                    position: "sticky",
                                    bottom: 0,
                                    background: "rgba(240, 242, 245, 0.9)",
                                    padding: "10px 0",
                                    boxShadow: "0 -2px 5px rgba(0, 0, 0, 0.1)",
                                    textAlign: "center",
                                }}
                            > 
                                <Button type="default" onClick={handleCancel} style={{ marginRight: 10 }}>
                                    Cancel
                                </Button>
                                <Button type="primary" htmlType="submit" >
                                    Save
                                </Button>
                            </div>
                        </Affix>


                    </Form>
                </Card>
            ) : (
                <div>
                <Row justify="space-between" align="middle" style={{ marginBottom: 20 }}>
                    <Col>
                        <Title level={3} style={{ margin: 0 }}>Sharing Rules</Title>
                    </Col>
                    <Col>
                        <Button type="primary" onClick={handleNew}>New</Button>
                    </Col>
                   
                </Row>

                    {/* Render layouts in a table */}
                    <Spin spinning={loading} size="size">
                    <Table
                        dataSource={sharingRules}
                        columns={columns}
                        rowKey="id"
                        pagination={false}
                    />
                    </Spin>
                </div>
              
            )}
        </div>
    );
};

export default SharingSettings;
